<template>
  <div>
    <div class="has-margin-bottom-40 has-margin-top-10 has-border-bottom">
      <h2
        class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
      >
        Shipper and Consignee Details
      </h2>
    </div>

    <div class="columns is-multiline">
      <!-- Shipper Name -->
      <div class="column is-6" v-if="data.shipper_name">
        <b-field label="Shipper/Consignor/Sender Name">
          <b-input v-model="data.shipper_name" readonly></b-input>
        </b-field>
      </div>

      <div class="column is-6" v-if="data.user_id">
        <b-field label="User ID">
          <b-input v-model="data.user_id" readonly></b-input>
        </b-field>
      </div>

      <!-- Shippers Address -->
      <div class="column is-6" v-if="data.shipper_address">
        <b-field label="Shipper/Consignor/Sender Address">
          <b-input v-model="data.shipper_address" readonly></b-input>
        </b-field>
      </div>

      <!-- Consignee Name -->
      <div class="column is-6" v-if="data.consignee_name">
        <b-field label="Consignee Name">
          <b-input v-model="data.consignee_name" readonly></b-input>
        </b-field>
      </div>

      <!-- Consignee Address -->
      <div class="column is-6" v-if="data.consignee_address">
        <b-field label="Consignee Address">
          <b-input v-model="data.consignee_address" readonly></b-input>
        </b-field>
      </div>

      <!-- Phone Number -->
      <div class="column is-6" v-if="data.shipper_phone_number">
        <b-field label="Phone Number">
          <b-input v-model="data.shipper_phone_number" readonly></b-input>
        </b-field>
      </div>

      <!-- Email Address -->
      <div class="column is-6" v-if="data.shipper_email">
        <b-field label="Email Address">
          <b-input v-model="data.shipper_email" readonly></b-input>
        </b-field>
      </div>

      <div class="column is-6" v-if="data.shipper_declaration_company_name">
        <b-field label="Shipper Declaration Company Name">
          <b-input
            v-model="data.shipper_declaration_company_name"
            readonly
          ></b-input>
        </b-field>
      </div>

      <div class="column is-6" v-if="data.shipper_declaration_date">
        <b-field label="Shipper Declaration Date">
          <b-input v-model="data.shipper_declaration_date" readonly></b-input>
        </b-field>
      </div>

      <div
        class="column is-6"
        v-if="data.shipper_declaration_name_of_declarant"
      >
        <b-field label="Shipper Declaration Name of Declarant">
          <b-input
            v-model="data.shipper_declaration_name_of_declarant"
            readonly
          ></b-input>
        </b-field>
      </div>

      <div
        class="column is-6"
        v-if="data.shipper_declaration_status_of_declarant"
      >
        <b-field label="Shipper Declaration Status of Declarant">
          <b-input
            v-model="data.shipper_declaration_status_of_declarant"
            readonly
          ></b-input>
        </b-field>
      </div>
    </div>

    <!-- EOF 1st Form Inputs -->
    <!--  -->

    <div class="has-margin-bottom-40 has-margin-top-40 has-border-bottom">
      <h2
        class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
      >
        Ship and Vessel Details
      </h2>
    </div>
    <!-- 2nd Form Inputs -->
    <div class="columns is-multiline">
      <!-- Ship Name -->
      <div class="column is-6" v-if="data.ship_name">
        <b-field label="Ship's Name">
          <b-input v-model="data.ship_name" readonly></b-input>
        </b-field>
      </div>

      <!-- Voyage Number -->
      <div class="column is-6" v-if="data.voyage_number">
        <b-field label="Voyage Number">
          <b-input v-model="data.voyage_number" readonly></b-input>
        </b-field>
      </div>

      <!-- Port of Loading -->
      <div class="column is-6" v-if="data.port_of_loading">
        <b-field label="Port of Loading">
          <b-input v-model="data.port_of_loading" readonly></b-input>
        </b-field>
      </div>

      <div class="column is-6" v-if="data.port_of_discharge_id">
        <b-field label="Port of Discharge">
          <b-input v-model="data.port_of_discharge_id" readonly></b-input>
        </b-field>
      </div>

      <div class="column is-6" v-if="data.status">
        <b-field label="Status">
          <b-input v-model="Status" readonly></b-input>
        </b-field>
      </div>

      <div class="column is-6" v-if="data.date_of_arrival">
        <b-field label="Date of Arrival">
          <b-input v-model="data.date_of_arrival" readonly></b-input>
        </b-field>
      </div>

      <div class="column is-6" v-if="data.date_of_departure">
        <b-field label="Date of Departure">
          <b-input v-model="data.date_of_departure" readonly></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShipperDetail",
  props: {
    data: Object
  },
  computed: {
    Status: function() {
      if (this.data.status === "AWAITING_PROCESSING") {
        return "AWAITING REVIEW";
      } else if (this.data.status === "PENDING") {
        return "PENDING";
      } else if (this.data.status === "APPROVED") {
        return "APPROVED";
      } else {
        return "DENIED";
      }
    }
  }
};
</script>
